import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledWrapper = styled(InnerComponent).attrs({ Component: components.ValueContainer })`
  &.react-select__value-container {
    padding: 0;
    line-height: 16px;
    cursor: text;
    flex-wrap: nowrap;
    white-space: nowrap;
    top: 1px;
  }

  .react-select__input-container {
    order: 2;
    margin: 0;
    padding: 0;
    .react-select__input {
      margin: 0;
      height: 16px;
    }
  }
`

const ValueContainer = ({ children, ...props }) => {
  return (
    <StyledWrapper {...props}>
      {children}
    </StyledWrapper>
  )
}

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object,
}

export default ValueContainer
